module.exports = __webpack_public_path__ + "media/images/logo-icon-aecc779d96a40b8e9f082cbec5fd968c.svg";